<template>
  <div>
    <div v-show="true">
      <f7-sheet
        class="enterPINSheet wandr-sheet-modal"
        :opened="sheetOpened"
        @sheet:closed="sheetOpened = false"
        :close-by-backdrop-click="closeByBackdrop"
        :close-by-outside-click="closeByOutside"
        backdrop
        style="height:auto;"
      >
        <f7-block>
          <div class="fs-18 fw-semibold mb-lg break-text">
            <span v-if="title.trim() != ''">{{ title }}</span>
            <span v-if="title.trim() == ''">
              {{$t('label-welcome-back')}}{{ (customerAlias != '' && customerAlias.toLowerCase() != 'customer') ? (', ' + customerAlias) : '' }}!
            </span>
          </div>

          <transition name="fade">
            <f7-card
              class="alert alert-danger mt-md"
              no-shadow
              v-show="alertCard.show"
            >
              <div v-html="alertCard.title" slot="header"></div>
              <i
                class="icon f7-icons card-close"
                @click="alertCard.show = false"
                >xmark</i
              >
            </f7-card>
          </transition>
        </f7-block>

        <f7-block v-if="showInputPassword && !isAxsr">
          <f7-list form class="form-group refresh-token" @submit="goToNextPage">
            <f7-list-input
              input-id="refresh-user-pin"
              name="refresh-user-pin"
              :type="passwordInputType"
              class="password"
              :label="$t('general-text-password')"
              :placeholder="$t('placeholder-password')"
              :value="userPin"
              @input="userPin = $event.target.value; validateInput($event.target);"
              minlength="8"
              outline
              floating-label
              required
            >
              <div class="toggle-password" @click="showHidePassword" id="password-icon" toggle="#password-field" slot="content-end" style="">
                <i class="f7-icons">eye_slash</i>
              </div>
            </f7-list-input>
          </f7-list>

          <div class="text-align-right mb-xl">
            <a @click="confirmResetPIN" class="wandr-level-3">{{
              $t("label-forgot-password")
            }}</a>
          </div>
        </f7-block>

        <f7-block class="no-padding margin mb-md">
          <f7-button
            v-if="showInputPassword && !isAxsr"
            @click="goToNextPage"
            large
            fill
            round
            :disabled="isFormInputValid ? false : true"
            >{{ submitButtonText.trim() == "" ? $t('general-btn-login') : submitButtonText }}</f7-button
          >

          <div v-if="!showInputPassword && !isAxsr" class="div-button ios" style="width: 100%;" @click="openAppleSignIn"><f7-icon f7="logo_apple" size="20px" class="mr-sm"></f7-icon> {{$t('general-text-apple-sign-in')}}</div>
        </f7-block>

        <f7-block v-if="showBiometryButton && !isAxsr" class="no-padding margin mb-md">
          <div class="login-with-biometry display-flex justify-content-center align-items-center fs-16 fw-semibold pointer" @click="loginWithBiometry">
            <img
              class="biometry-icon mr-sm"
              :src="require('@/assets/img/icon/icon-' + (biometryType == 1 ? 'fingerprint' : 'face_id') + '.svg')"
              style="height:24px"
            />
            {{ biometryType == 1 ? $t('general-text-finger-print') : (biometryType == 2 ? $t('general-text-face-id') : "") }}
          </div>
        </f7-block>

        <!-- AXS -->
        <f7-block class="no-padding margin mb-md" v-if="isAxsr">
          <f7-button  large fill v-if="isAxsr" 
            class="bg-color-red2 text-color-white mb-20 display-flex align-items-center justify-content-center b fs-16"
            @click="goToNextPage"
            :disabled="false">
            {{$t('login-login-with')}} <img :src="require('@/assets/img/icon/icon-singpass.svg')" class="ml-sm img-white" style="height:15px; margin-top: 6px;" />
          </f7-button>

          <div v-if="!showInputPassword && !isAxsr" class="div-button ios" style="width: 100%;" @click="openAppleSignIn"><f7-icon f7="logo_apple" size="20px" class="mr-sm"></f7-icon> {{$t('general-text-apple-sign-in')}}</div>
        </f7-block>
        <!-- END OF AXS-->
      </f7-sheet>

      <f7-sheet
        class="confirmResetPINSheet wandr-sheet-modal"
        :opened="sheetResetOpened"
        @sheet:closed="sheetResetOpened = false"
        :close-by-backdrop-click="closeByBackdrop"
        :close-by-outside-click="closeByOutside"
        backdrop
      >
        <f7-block>
          <div class="wandr-level-2">{{ $t("title-reset-pin") }}</div>
          <div class="wandr-paragraph-4">{{ $t("label-reset-pin") }}</div>
          <f7-block class="mt-24">
            <f7-row>
              <f7-col>
                <f7-button
                  @click="resetPIN(false)"
                  outline
                  round
                  large
                  color="primary"
                  id="btnNo"
                  >{{ $t("general-btn-no") }}</f7-button
                >
              </f7-col>
              <f7-col>
                <f7-button
                  @click="resetPIN(true)"
                  fill
                  round
                  large
                  color="primary"
                  id="btnYes"
                  >{{ $t("general-btn-yes") }}</f7-button
                >
              </f7-col>
            </f7-row>
          </f7-block>
        </f7-block>
      </f7-sheet>
      <f7-sheet
        class="authenticationSheet wandr-sheet-modal"
        :opened="showPopUp"
        @sheet:closed="popUpOpened = false"
        :close-by-backdrop-click="closeByBackdrop"
        :close-by-outside-click="closeByOutside"
        backdrop
        style="height:auto;"
      >
        <f7-block>
          <div class="row no-gap login-with-biometry display-flex justify-content-center align-items-center fs-16 fw-semibold">
            <img class="biometry-icon mr-sm" :src="require('@/assets/img/icon/icon-' + (biometryType == 1 ? 'fingerprint' : 'face_id') + '.svg')" style="height:24px"/>
            {{ biometryType == 1 ? $t('general-text-finger-print') : (biometryType == 2 ? $t('general-text-face-id') : "") }}
          </div>

          <div class="display-flex flex-direction-column justify-content-center mt-xxl mb-xl">
            <img class="biometry-icon" :src="require('@/assets/img/icon/icon-'+(biometryType == 1 ? 'fingerprint' : 'face_id')+'.svg')" style="height:100px" />
          </div>
        </f7-block>
      </f7-sheet>
    </div>
  </div>
</template>

<script>
// we must import our Modal plugin instance
// because it contains reference to our Eventbus
import Modal from "../plugins/session-plugin.js";
//import { check } from '@/plugins/helper';
import CryptoAES from "aes-ecb";
import { mapGetters, mapActions } from "vuex";
import ApiService from "../services/api-main";
import store from '../store';

export default {
  components: {},
  destroyed() {
    if (window.singpassLoginCallback) window.singpassLoginCallback = null;
    if (window.singpassLoginFailed) window.singpassLoginFailed = null;
    if (this.isAxsr) {
      window.removeEventListener('message', this.handleSingpassMessage);
      window.removeEventListener('storage', this.handleSingpassStorage);
    }
  },
  data() {
    return {
      visible: false,
      title: "",
      text: "",
      onSuccess: {},
      sheetOpened: false,
      sheetResetOpened: false,
      closeByBackdrop: false,
      closeByOutside: false,
      backdrop: true,
      userPin: "",
      validated: false,
      isFormInputValid: false,
      passwordInputType: "password",
      alertCard: {
        show: false,
        title: "",
        content: "",
      },
      showPopUp: false,
      biometryType: 0,
      showInputPassword: false,
      showBiometryButton: false,
      submitButtonText : "",
      isEditEmail: false,
      isEditMobileNo: false,
      oldEmail: "",
      newEmail: "",
      oldMobileCountryId: 0,
      oldMobileNo: "",
      newMobileCountryId: 0,
      newMobileNo: "",
      token: "",
      newCustomerId : 0,
      checkWindow : undefined
    };
  },
  mounted() {
    if(window.Android || window.webkit) {
      this.showPreloader();
      this.checkBiometryAvaibility();
      this.$root.$once("handleBiometryType", (type) => {
        // 0 = None, 1 = Fingerprint, 2 = Face ID
        this.biometryType = type;
        this.hidePreloader();
      });
    }

    // CHECK IF AXSR
    console.log("Refresh token mounted, isAxsr : "+this.isAxsr);
    window.singpassLoginCallback  = this.singpassLoginCallback;
    window.singpassLoginFailed    = this.singpassLoginFailed;
    if(this.isAxsr) {
      window.addEventListener('message', this.handleSingpassMessage);
      window.addEventListener('storage', this.handleSingpassStorage);
    }
  },
  computed: {
    ...mapGetters("auth", [
      "authenticating",
      "authenticationError",
      "authenticationErrorCode",
      "authenticationSuccess",
      "loggedIn"
    ]),

    ...mapGetters("customer", ["customerAlias"]),
    ...mapGetters('registration', ['isAxsr']),
  },
  methods: {
    ...mapActions("auth", ["refreshExpiredToken", "logout"]),
    ...mapActions("customer", ["setCustomerAlias", "setTempUpdateAccountToken"]),
    ...mapActions("registration", ["setIsAxsr"]),
    ...mapActions("misc", ["setIsWrongReloginCustomerId"]),
    async goToNextPage(e){
      console.log(this.isEditEmail+" ### "+this.isEditMobileNo)
      if(this.isEditEmail){
        console.log("execute edit email")
        e.preventDefault();
        this.showPreloader();
        try {
            const result = await this.$api.customer.updateCustomerEmail(this.userPin, '', this.oldEmail, this.newEmail);
            this.hidePreloader();
            
            if(result === undefined || result.length <= 0) {
                this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                return false;
            }

            this.setTempUpdateAccountToken("")
            this.$f7.sheet.close(".enterPINSheet", true);
            this.toggleAlert(false);
            this.alertCard.title = ""
            this.$f7.views.main.router.navigate("/account/email-verify");
        } catch(e){
            this.hidePreloader();
            this.setTempUpdateAccountToken("")
            if(e.message.toLowerCase().includes("undefined")) {
                this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            } else {
                //this.$f7.dialog.alert(e.message);
                this.toggleAlert(true, e.message, '');
            }
        }
      }else if(this.isEditMobileNo){
        console.log("execute edit mobile no")
        e.preventDefault();
        this.showPreloader();
        try {
            var updateData = store.state.misc;
            updateData.mobileCountryId = this.oldMobileCountryId;
            updateData.mobileNo = this.oldMobileNo;
            updateData.newMobileCountryId = this.newMobileCountryId;
            updateData.newMobileNo = this.newMobileNo;
            updateData.password = this.userPin;
            updateData.appleToken = "";

            const result = await this.$api.customer.validateCustomerMobileNumber();
            if(result.status == 3132) {
                const result = await this.$api.otp.requestotp(4);
                this.hidePreloader();
                this.$f7.sheet.close(".enterPINSheet", true);
                this.toggleAlert(false);
                this.alertCard.title = ""
                if(result.status) {
                    updateData.otp.routerTo = 'editMobilePhone';
                    this.$f7.views.main.router.navigate("/otp");
                } else {
                    this.$f7.dialog.alert(result.message);
                }
            } else {
                this.hidePreloader();
                this.$f7.sheet.close(".enterPINSheet", true);
                this.toggleAlert(false);
                this.alertCard.title = ""
                this.$f7.dialog.alert(result.message);
                if(result.status == 3133 || result.status == 3139) {
                    //this.$f7router.back({ transition: 'f7-push' });
                }
            } 

        } catch(e){
            this.hidePreloader();
            if(e.message.toLowerCase().includes("undefined")) {
                this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            } else {
                //this.$f7.dialog.alert(e.message);
                this.toggleAlert(true, e.message, '');
            }

            this.$f7.sheet.close(".enterPINSheet", true);
            this.toggleAlert(false);
            this.alertCard.title = ""
        }
      }else{
        console.log("refresh token : doLogin")
        this.doLogin(e)
      }
    },
    async doLogin(e) {
      e.preventDefault();
      const self = this;
      self.showPreloader();

      // CHECK AXSR
      console.log("refresh token doLogin, isAxsr : "+self.isAxsr)

      if(self.isAxsr){ // SINGPASS LOGIN
        console.log("Singpass login...")
        self.hidePreloader();
        self.singpassLogin();
      }else{
        // var today = new Date();
        // var dd = String(today.getDate()).padStart(2, "0");
        // var MM = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        // var yy = today
        //   .getFullYear()
        //   .toString()
        //   .substr(-2);
        // var todayNew = MM + dd + yy;

        const randVal = await ApiService.getRandomValue();
        const secretKey = process.env.VUE_APP_PSSTK + randVal;
        const encryptedPassword = CryptoAES.encrypt(secretKey, self.userPin);

        await self.refreshExpiredToken({
          password: encryptedPassword,
        });

        self.hidePreloader();

        if (self.authenticationSuccess) {
          // console.log(result.p2hCustomerId);
          // self.sheetOpened = false;
          self.$f7.sheet.close(".enterPINSheet", true);
          self.toggleAlert(false);
          self.alertCard.title = ""
          self.confirm();
        } else {
          //console.log("authenticationErrorCode: " + self.authenticationErrorCode);
          let errMsg = "";
          // WRONG PASSWORD
          if (self.authenticationErrorCode == "WN00009") {
            errMsg = self.$t("alert-invalid-password")
          }
          // EXCEDEED MAX ATTEMPT
          else if (self.authenticationErrorCode == "WN00007") {
            errMsg = self.$t('alert-login-max-attempt', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK})
            self.$f7.sheet.close(".enterPINSheet", true);
            self.toggleAlert(false);
            self.alertCard.title = ""
            self.$f7.dialog.alert(self.$t('alert-login-max-attempt', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}), function(){
              self.logout();
              self.$f7.views.main.router.navigate("/login");
            });
          }
          // EMAIL INACTIVE (TEMPORARY SUSPENDED)
          else if (self.authenticationErrorCode == "WN00005") {
            errMsg = self.$t("reset-password-email-inactive")
            self.$f7.sheet.close(".enterPINSheet", true);
            self.toggleAlert(false);
            self.alertCard.title = ""
            self.$f7.dialog.alert(self.$t("reset-password-email-inactive"), function(){
              self.logout();
              self.$f7.views.main.router.navigate("/login");
            });
          }
          // OTHERS
          else{
            errMsg = self.$t("regis-err-SH2013")
          }

          self.setInputState(
            "refresh-user-pin",
            errMsg
          );

          /*
          if (self.authenticationErrorCode == "OV00007") {
            // Maximum attempt exceeded
            await self.$f7.sheet.close(".enterPINSheet", true);
            // Logout
            await self.logout();
            self.$f7.views.main.router.navigate("/?force=1");
          } else {
            self.setInputState(
              "refresh-user-pin",
              self.$t("regis-err-SH2013")
            );
          }
          */
        }
      }
    },
    hide() {
      // this method is unchanged
    },
    confirm() {
      this.toggleAlert(false);
      // we must check if this.onSuccess is function
      // console.log(typeof this.onSuccess);
      // console.log(this.onSuccess);
      if (typeof this.onSuccess === "function") {
        // run passed function and then close the modal
        this.onSuccess();
        //   this.hide();
        // } else {
        //   // we only close the modal
        //   this.hide();
      }

      if(this.$store.state.misc.redirectToPath != '') {
        const paths = this.$store.state.misc.redirectToPath.split("?");
        this.navigateRoute(paths[0], (paths.length == 1)?undefined:paths[1]);
      }
    },
    show(params) {
      // this.visible = true
      // this.title = params.title
      // this.text = params.text
      // setting callback function
      // console.log(params.onSuccess);

      console.log("closeByOutside : "+params.closeByOutside)
      console.log("closeByBackdrop : "+params.closeByBackdrop)
      console.log("isEditEmail : "+params.isEditEmail)
      console.log("isEditMobileNo : "+params.isEditMobileNo)
      console.log("oldEmail : "+params.oldEmail)
      console.log("newEmail : "+params.newEmail)
      console.log("oldMobileCountryId : "+params.oldMobileCountryId)
      console.log("oldMobileNo : "+params.oldMobileNo)
      console.log("newMobileCountryId : "+params.newMobileCountryId)
      console.log("newMobileNo : "+params.newMobileNo)        


      this.isEditEmail = params.isEditEmail != undefined ? params.isEditEmail : false
      this.isEditMobileNo = params.isEditMobileNo != undefined ? params.isEditMobileNo : false
      this.oldEmail = params.oldEmail != undefined ? params.oldEmail : ""
      this.newEmail = params.newEmail != undefined ? params.newEmail : ""
      this.oldMobileCountryId = params.oldMobileCountryId != undefined ? params.oldMobileCountryId : 0
      this.oldMobileNo = params.oldMobileNo != undefined ? params.oldMobileNo : ""
      this.newMobileCountryId = params.newMobileCountryId != undefined ? params.newMobileCountryId : 0
      this.newMobileNo = params.newMobileNo != undefined ? params.newMobileNo : ""
      this.token = params.appleIdToken != undefined ? params.appleIdToken : ""
      this.closeByOutside = params.closeByOutside != undefined ? params.closeByOutside : false
      this.closeByBackdrop = params.closeByBackdrop != undefined ? params.closeByBackdrop : false
      
      this.submitButtonText = params.submitButtonText != undefined ? params.submitButtonText : ""

      this.onSuccess = params.onSuccess;
      // this.sheetOpened = true
      this.$f7.sheet.open(".enterPINSheet", true);
      this.userPin = "";
      //this.toggleAlert(false);
      this.showBiometryButton = ApiService.getFormData("is_using_biometry")?true:false;
      this.showInputPassword = !ApiService.getFormData("passReq") || ApiService.getFormData("passReq") == 'true';

      this.title = this.showInputPassword ? (params.title != undefined ? params.title : "") : ""
    },
    validateInput(inputEl) {
      let isValidInput = false;
      //const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

      if (inputEl.id === "refresh-user-pin") {
        isValidInput = true; //regex.test(inputEl.value); // WandrE Issue List #251 - VALIDATION REMOVED

        let inputState = isValidInput
          ? true
          : this.$t((inputEl.value == '')?'placeholder-password':'regis-password-rule');
        this.setInputState(inputEl, inputState);
      }

      /* // WandrE Issue List #251 - VALIDATION REMOVED
      this.isFormInputValid =
        this.$$(".form-group.refresh-token").find(".item-input-valid").length >=
        1
          ? true
          : false;
      */

      this.isFormInputValid = this.userPin.trim() == "" ? false : true
    },

    toggleAlert(show, title, content) {
      this.alertCard.show = show;
      this.alertCard.title = title;
      this.alertCard.content = content;
    },

    confirmResetPIN() {
      // this.sheetOpened = false
      this.$f7.sheet.close(".enterPINSheet", false);
      // this.sheetResetOpened = true
      // this.$f7.sheet.open(".confirmResetPINSheet", false);
      this.$f7.views.main.router.navigate("/reset-password-email?pid=popup");
    },

    resetPIN(confirmReset) {
      if (confirmReset) {
        // this.sheetResetOpened = false
        this.$f7.sheet.close(".confirmResetPINSheet", false);
        this.logout();
        this.$f7.views.main.router.navigate("/");
      } else {
        // this.sheetResetOpened = false
        this.$f7.sheet.close(".confirmResetPINSheet", false);
        // this.sheetOpened = true
        this.$f7.sheet.open(".enterPINSheet", false);
      }
    },

    loginWithBiometry() {
      if(ApiService.getFormData("is_using_biometry")) {
        this.showPopUp = true;
        this.$f7.sheet.close(".enterPINSheet", false);
        this.$f7.sheet.open(".authenticationSheet", true);
        this.loginAuthentication();
      }
    },
    loginAuthentication() {
      if (window.Android || window.webkit) {
        this.openDeviceBiometry();

        this.$root.$once("handleValidationBiometryStatus", async (status) => {
          this.showPopUp = false;
          this.$f7.sheet.close(".authenticationSheet", false);

          if(status) {
            if(this.isEditEmail){
              console.log("execute edit email with biometry")
              this.showPreloader();
              try {
                  let result;
                  if(this.token == ""){
                    result = await this.$api.customer.updateCustomerEmail(this.userPin, '', this.oldEmail, this.newEmail);
                  }else{
                    result = await this.$api.customer.updateCustomerEmail('', this.token, this.oldEmail, this.newEmail);
                  }
                  this.hidePreloader();
                  
                  if(result === undefined || result.length <= 0) {
                      this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                      return false;
                  }

                  this.setTempUpdateAccountToken("")
                  this.$f7.sheet.close(".enterPINSheet", true);
                  this.toggleAlert(false);
                  this.alertCard.title = ""
                  this.$f7.views.main.router.navigate("/account/email-verify");
              } catch(e){
                  this.hidePreloader();
                  this.setTempUpdateAccountToken("")
                  this.$f7.sheet.close(".enterPINSheet", true);
                  this.toggleAlert(false);
                  this.alertCard.title = ""
                  if(e.message.toLowerCase().includes("undefined")) {
                      this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                  } else {
                      //this.$f7.dialog.alert(e.message);
                      this.toggleAlert(true, e.message, '');
                  }
              }
            }else if(this.isEditMobileNo){
              console.log("execute edit mobile no with biometry")
              this.showPreloader();
              try {
                  var updateData = store.state.misc;
                  updateData.mobileCountryId = this.oldMobileCountryId;
                  updateData.mobileNo = this.oldMobileNo;
                  updateData.newMobileCountryId = this.newMobileCountryId;
                  updateData.newMobileNo = this.newMobileNo;
                  updateData.password = this.userPin;
                  updateData.appleToken = "";

                  const result = await this.$api.customer.validateCustomerMobileNumber();
                  this.$f7.sheet.close(".enterPINSheet", true);
                  this.toggleAlert(false);
                  this.alertCard.title = ""
                  if(result.status == 3132) {
                      const result = await this.$api.otp.requestotp(4);
                      this.hidePreloader();
                      if(result.status) {
                          updateData.otp.routerTo = 'editMobilePhone';
                          this.$f7.views.main.router.navigate("/otp");
                      } else {
                          this.$f7.dialog.alert(result.message);
                      }
                  } else {
                      this.hidePreloader();
                      this.$f7.dialog.alert(result.message);
                      if(result.status == 3133 || result.status == 3139) {
                          //this.$f7router.back({ transition: 'f7-push' });
                      }
                  } 
              } catch(e){
                  this.hidePreloader();
                  if(e.message.toLowerCase().includes("undefined")) {
                      this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                  } else {
                      //this.$f7.dialog.alert(e.message);
                      this.toggleAlert(true, e.message, '');
                  }

                  this.$f7.sheet.close(".enterPINSheet", true);
                  this.toggleAlert(false);
                  this.alertCard.title = ""
              }
            }else{
              this.$f7.sheet.close(".enterPINSheet", true);
              this.toggleAlert(false);
              this.alertCard.title = ""
              this.confirm();
            }
          } else {
            this.$f7.sheet.open(".enterPINSheet", true);
          }
        });

        // setTimeout(() => {
        //     this.disabledButton = true;
        // }, 2000)
        // }
      }
    },
    showHidePassword(){
      let $$ = this.Dom7;
      if(this.passwordInputType == "password"){
        this.passwordInputType = "text";
        $$("#password-icon").html('<i class="f7-icons">eye</i>');
      }else{
        this.passwordInputType = "password";
        $$("#password-icon").html('<i class="f7-icons">eye_slash</i>');
      }
    },
    openAppleSignIn() {
      if(window.AppleID) {
        const self = this;
        self.toggleAlert(false);
        self.appleSignIn(3, false);

        self.$root.$once('handleApleValidationStatus', async (token) => {
          if(self.isEditEmail){
            console.log("execute edit email apple signin")
            self.showPreloader();
            try {
                const result = await self.$api.customer.updateCustomerEmail('', token, self.oldEmail, self.newEmail);
                self.hidePreloader();
                
                if(result === undefined || result.length <= 0) {
                    self.$f7.dialog.alert(self.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    return false;
                }

                self.setTempUpdateAccountToken("")
                self.$f7.sheet.close(".enterPINSheet", true);
                self.toggleAlert(false);
                self.alertCard.title = ""
                self.$f7.views.main.router.navigate("/account/email-verify");
            } catch(e){
                self.hidePreloader();
                self.setTempUpdateAccountToken("")
                if(e.message.toLowerCase().includes("undefined")) {
                    self.$f7.dialog.alert(self.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                } else {
                    //self.$f7.dialog.alert(e.message);
                    self.toggleAlert(true, e.message, '');
                }
            }
          }else if(self.isEditMobileNo){
            console.log("execute edit mobile no")
            try {
                var updateData = store.state.misc;
                updateData.mobileCountryId = this.oldMobileCountryId;
                updateData.mobileNo = this.oldMobileNo;
                updateData.newMobileCountryId = this.newMobileCountryId;
                updateData.newMobileNo = this.newMobileNo;
                updateData.password = '';
                updateData.appleToken = token;

                const result = await self.$api.customer.validateCustomerMobileNumber();
                if(result.status == 3132) {
                    const result = await self.$api.otp.requestotp(4);
                    self.hidePreloader();
                    self.$f7.sheet.close(".enterPINSheet", true);
                    self.toggleAlert(false);
                    self.alertCard.title = ""
                    if(result.status) {
                        updateData.otp.routerTo = 'editMobilePhone';
                        self.$f7.views.main.router.navigate("/otp");
                    } else {
                        self.$f7.dialog.alert(result.message);
                    }
                } else {
                    self.hidePreloader();
                    self.$f7.sheet.close(".enterPINSheet", true);
                    self.toggleAlert(false);
                    self.alertCard.title = ""
                    self.$f7.dialog.alert(result.message);
                    if(result.status == 3133 || result.status == 3139) {
                        //self.$f7router.back({ transition: 'f7-push' });
                    }
                } 

            } catch(e){
                self.hidePreloader();
                if(e.message.toLowerCase().includes("undefined")) {
                    self.$f7.dialog.alert(self.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                } else {
                    //self.$f7.dialog.alert(e.message);
                    self.toggleAlert(true, e.message, '');
                }

                self.$f7.sheet.close(".enterPINSheet", true);
                self.toggleAlert(false);
                self.alertCard.title = ""
            }
          }else{
            self.showPreloader();
            try {
              const result = await self.$api.customer.appleLogin(token, true);
              self.hidePreloader();
              if(result.status == '0100') {
                self.$f7.sheet.close(".enterPINSheet", true);
                self.toggleAlert(false);
                self.alertCard.title = ""
                self.confirm();
              } else if(result.status == "0105") { // ACCOUNT SUSPENDED
                self.toggleAlert(true, self.$t('reset-password-email-inactive'), '');
              } else if(result.status == "WN00102") { // MULTIPLE EMAIL FOUND
                self.toggleAlert(true, self.$t('regis-multiple-user-err'), '');
              } else if(result.status == "WN00115") { // INVALID EMAIL
                self.toggleAlert(true, self.$t('login-err-WN00115-apple'), '');
              } else if(result.status == "WN00117") { // GENERAL
                self.toggleAlert(true, self.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}), '');
              } else if(result.status == "WN00118" || result.status == "INVALID_EMAIL_OR_CRN") {
                self.toggleAlert(true, self.$t('regis-email-invalid'), '');
              } else {
                self.toggleAlert(true, result.message, '');
              }
            } catch(e){
              self.hidePreloader();
              if(e.message.toLowerCase().includes("undefined")) {
                  self.toggleAlert(true, self.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}), '');
              } else {
                  self.toggleAlert(true, e.message, '');
              }
            } 
          }
        });
      }
    },

    singpassLogin(){
      const self = this;
      self.showPreloader();

      this.setIsAxsr(true)
      console.log("singpassLogin onclick : is AXS ? "+this.isAxsr)

      // Reclaim the global callback handoff every time we start our own flow.
      // mounted() only runs once at app boot; axsr-login.vue/login.vue mount
      // later and overwrite window.singpassLoginCallback with their own
      // method for the duration of their own SingPass flow, and their
      // destroyed() hook doesn't reliably hand it back. Without this, the
      // popup we open here calls back into a stale, no-longer-relevant
      // component instance whose own checkWindow is unrelated to this popup,
      // so it never gets closed.
      window.singpassLoginCallback = this.singpassLoginCallback;
      window.singpassLoginFailed   = this.singpassLoginFailed;

      const isUsingInAppBrowser = self.isMyInfoUseInAppBrowser();
      if(self.checkTimer) {
        clearInterval(self.checkTimer);
      }
      if(!isUsingInAppBrowser) {
        self.checkTimer = setInterval(function(){ if(self.checkWindow && self.checkWindow.closed) {self.singpassLoginCompleted(false);} }, 1000);
      }

      if(self.$f7.device.ios && !isUsingInAppBrowser && self.checkWindow == undefined) {
        self.checkWindow = window.open('about:blank', '_blank', "fullscreen=1");
      }

      this.$api.customer.getSingpassURL(isUsingInAppBrowser, 1).then(function(response) {
        if(response && response != undefined && response.value != '') {
          if(isUsingInAppBrowser) {
            self.openMyInfoInMobile(response.value);
            self.$root.$once("proceedMyInfoMobileCallback", (isUserCancel, state, code) => {
              if(isUserCancel) {
                self.singpassLoginCompleted(false);
              } else {
                self.singpassLoginCallback(state, code);
              }
            });
          } else if(self.checkWindow !== undefined) {
            self.checkWindow.location.replace(response.value);
          } else {
            self.checkWindow = window.open(response.value, '_blank', "fullscreen=1");
          }
        } else {
          if(self.checkWindow !== undefined) {
            clearInterval(this.checkTimer);
            self.checkWindow.close();
            self.checkWindow = undefined;
          }
          self.hidePreloader();
        }
      });
    },

    handleSingpassMessage(event) {
      const allowedOrigins = [
        window.location.origin,
        process.env.VUE_APP_SINGPASS_CALLBACK_ORIGIN,
      ].filter(Boolean);
      if (!allowedOrigins.includes(event.origin)) return;
      if (event.data && event.data.type === 'singpassCallback') {
        this.singpassLoginCallback(event.data.state, event.data.code);
      }
    },
    // DR-2118 follow-up: login-singpass-callback.vue's fallback when it has no
    // window.opener reference at all (some mobile WebViews lose this even for a
    // same-origin popup) - it writes here instead, and any listening tab/window
    // picks it up via the 'storage' event, which doesn't need an opener/popup
    // object reference. Route through window.singpassLoginCallback (the reclaimed
    // global), not this.singpassLoginCallback directly, so only the currently
    // active flow's instance handles it, same as handleSingpassMessage's siblings.
    handleSingpassStorage(event) {
      if (event.key !== 'singpassCallbackPending' || !event.newValue) return;
      try {
        const payload = JSON.parse(event.newValue);
        if (window.singpassLoginCallback) {
          window.singpassLoginCallback(payload.state, payload.code);
        }
      } catch (e) {
        // malformed payload - nothing to recover
      } finally {
        localStorage.removeItem('singpassCallbackPending');
      }
    },
    singpassLoginCallback(state, code){
      if (code == '' || state == '') {
        this.singpassLoginFailed(1);
      }
      const self = this;
      self.$api.customer.singpassLogin(self.isMyInfoUseInAppBrowser(), state, code).then(function(result) {
        self.hidePreloader();
        if(result.status == '0100') {
          self.setCustomerUsingBiometry(result.result.p2hCustomerId, 2);
          self.newCustomerId = result.result.p2hCustomerId
          self.singpassLoginCompleted(true);
        } else if(result.status == "WN00120") { // Customer not found
          self.singpassLoginFailed(2);
        } else {
          self.singpassLoginFailed(1);
        }
      }).catch(function() {
        self.singpassLoginFailed(1);
      });
    },
    singpassLoginCompleted(navigateToNextPage){
      this.hidePreloader();
      this.closePopupOnMobile();
      if(this.checkWindow !== undefined) {
        clearInterval(this.checkTimer);
        this.checkWindow.close();
        this.checkWindow = undefined;
      }
      if(navigateToNextPage) {
        this.$f7.sheet.close(".enterPINSheet", true);
        this.toggleAlert(false);
        this.alertCard.title = ""
        if(this.newCustomerId == this.$store.state.customer.customerId){
          this.setIsWrongReloginCustomerId(false)
          this.confirm();
        }
        else{
          // do logout, redirect to login screen with err msg\
          console.log("Relogin, CRN doesnt match, do logout")
          this.setIsWrongReloginCustomerId(true)
          this.logout();
          if(!this.authenticationSuccess && !this.loggedIn){
            if(this.isAxsr){
              this.$f7.views.main.router.navigate("/axsr-login");
            }else{
              this.$f7.views.main.router.navigate("/login");
            }
          }
        }
      }
    },
    singpassLoginFailed(errorType){
      const self = this;
      this.hidePreloader();
      this.closePopupOnMobile();
      if(this.checkWindow !== undefined) {
        clearInterval(this.checkTimer);
        this.checkWindow.close();
        this.checkWindow = undefined;
      }

      switch (errorType) {
        case 2: {
          self.toggleAlert(true, self.$t('login-singpass-user-not-found-desc', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}), '');
          break;
        }
        default:
          self.toggleAlert(true, self.$t('login-singpass-unavailable'), '');
          break;
      }
    },
  },
  beforeMount() {
    // here we need to listen for emited events
    // we declared those events inside our plugin
    Modal.EventBus.$on("show", (params) => {
      if (
        this.$api.token.getToken() &&
        this.$api.token.getToken() != undefined &&
        (!this.customerAlias || this.customerAlias == "")
      ) {
        this.setCustomerAlias(ApiService.getFormData("custAlias")?ApiService.getFormData("custAlias"):'');
      }
      
      this.show(params);
    });
  },
};
</script>
